"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Converts a string to a URL.
 * @param {} uri
 */
var UrlBuilder = function UrlBuilder(uri) {
  if (uri) {
    uri = uri.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '-'); // Replace all weird chars to a '-' char, to make nice url's.

    if (uri.endsWith('-')) {
      uri = uri.slice(0, -1);
    }
  }

  return uri;
};

var _default = UrlBuilder;
exports["default"] = _default;